(() => {
  const cartRoots = ['.cart-page', '.cart-page__summary', '.cart-items__wrapper'];
  const hasCart = () => cartRoots.some((selector) => document.querySelector(selector));
  const globalStyleId = 'sla-shop-global-polish-style';
  const polishStyleId = 'sla-cart-final-polish-style';
  let textPolishTimer = null;

  function injectGlobalPolish() {
    if (document.getElementById(globalStyleId)) return;

    const style = document.createElement('style');
    style.id = globalStyleId;
    style.textContent = `
      :is(.slx-newsletter, .slq-newsletter, .newsletter, .newsletter-section, .email-signup-banner, [class*="newsletter"]) {
        color: #10110d !important;
      }

      :is(.slx-newsletter, .slq-newsletter, .newsletter, .newsletter-section, .email-signup-banner, [class*="newsletter"]) :is(h1, h2, h3, p, span, strong, small, label, .eyebrow, [class*="kicker"]) {
        color: #10110d !important;
        opacity: 1 !important;
      }

      :is(.slx-newsletter, .slq-newsletter, .newsletter, .newsletter-section, .email-signup-banner, [class*="newsletter"]) :is(input, textarea) {
        color: #f5f5f7 !important;
        background: #151515 !important;
        border-color: rgba(16, 17, 13, 0.18) !important;
      }

      :is(.slx-newsletter, .slq-newsletter, .newsletter, .newsletter-section, .email-signup-banner, [class*="newsletter"]) :is(input, textarea)::placeholder {
        color: rgba(245, 245, 247, 0.62) !important;
        opacity: 1 !important;
      }

      :is(.slx-card, .slq-card, .featured-product-card, [class*="favorite"] .product-card, [class*="bestseller"] .product-card) :is(.slx-price, .price, .price *, price-list, sale-price, .money) {
        color: #f5f5f7 !important;
        opacity: 1 !important;
        text-shadow: none !important;
      }

      :is(.slx-card, .slq-card, .featured-product-card, [class*="favorite"] .product-card, [class*="bestseller"] .product-card) :is(.compare-at-price, .compare-at-price *, .slx-compare) {
        color: rgba(245, 245, 247, 0.58) !important;
        opacity: 1 !important;
      }

      .product-grid .product-card :is(.price, .price *, .money) {
        color: #111113 !important;
        opacity: 1 !important;
      }

      body :is(.slx-card, .slq-card, .featured-product-card, [class*="favorite"] .product-card, [class*="bestseller"] .product-card) :is(.slx-price, .price, .price *, price-list, sale-price, .money) {
        color: #f5f5f7 !important;
        opacity: 1 !important;
        text-shadow: none !important;
      }

      body :is(.slx-card, .slq-card, .featured-product-card, [class*="favorite"] .product-card, [class*="bestseller"] .product-card) :is(.compare-at-price, .compare-at-price *, .slx-compare) {
        color: rgba(245, 245, 247, 0.58) !important;
        opacity: 1 !important;
      }

      body #header-group,
      body header-component,
      body .shopify-section-group-header-group,
      body .header-wrapper {
        background: rgba(12, 12, 13, 0.94) !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
        box-shadow: none !important;
        backdrop-filter: blur(18px) saturate(150%);
        -webkit-backdrop-filter: blur(18px) saturate(150%);
      }

      body .header,
      body .header__row,
      body header-component .section {
        min-height: 64px !important;
      }

      body .header__row {
        width: min(1200px, calc(100% - 32px)) !important;
        margin-inline: auto !important;
        padding-block: 10px !important;
        gap: 18px !important;
      }

      body .header-logo__image-container:empty,
      body .header-logo__image-container:not(:has(img)) {
        display: none !important;
      }

      body .header-logo,
      body .header-logo *,
      body .sl-header-wordmark {
        color: #f5f5f7 !important;
        letter-spacing: 0 !important;
        text-decoration: none !important;
      }

      body .header-logo {
        display: inline-flex !important;
        width: auto !important;
        max-width: none !important;
        min-width: 0 !important;
        align-items: center !important;
        gap: 10px !important;
        font-size: 0.98rem !important;
        font-weight: 850 !important;
      }

      body .header-actions {
        gap: 10px !important;
      }

      body :is(.header-actions__action, .header__icon, .header button, .menu-drawer__menu-button) {
        min-width: 38px !important;
        width: 38px !important;
        height: 38px !important;
        min-height: 38px !important;
        border: 1px solid rgba(255, 255, 255, 0.12) !important;
        border-radius: 999px !important;
        background: rgba(255, 255, 255, 0.045) !important;
        color: #f5f5f7 !important;
        box-shadow: none !important;
      }

      body :is(.header-actions__action, .header__icon, .header button, .menu-drawer__menu-button):is(:hover, :focus-visible) {
        background: rgba(255, 255, 255, 0.1) !important;
        border-color: rgba(255, 255, 255, 0.2) !important;
        outline: none !important;
      }

      body :is([class*="trustbar"], [class*="trust-bar"]) {
        background: rgba(215, 255, 34, 0.055) !important;
        border-block: 1px solid rgba(255, 255, 255, 0.07) !important;
      }

      body :is([class*="trustbar"], [class*="trust-bar"]) :is(h1, h2, h3, p, span, strong, a) {
        color: rgba(245, 245, 247, 0.88) !important;
      }

      @media (max-width: 749px) {
        body .header__row {
          width: calc(100% - 24px) !important;
          min-height: 58px !important;
          padding-block: 8px !important;
        }

        body :is(.header-actions__action, .header__icon, .header button, .menu-drawer__menu-button) {
          width: 36px !important;
          height: 36px !important;
          min-width: 36px !important;
          min-height: 36px !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function replaceVisibleGermanText(root = document.body) {
    if (!root) return;

    const replacements = [
      [/ZUBEHOER/g, 'ZUBEH\u00D6R'],
      [/Zubehoer/g, 'Zubeh\u00F6r'],
      [/zubehoer/g, 'zubeh\u00F6r'],
      [/RUECKGABE/g, 'R\u00DCCKGABE'],
      [/Rueckgabe/g, 'R\u00FCckgabe'],
      [/rueckgabe/g, 'r\u00FCckgabe'],
      [/UEBERBLICK/g, '\u00DCBERBLICK'],
      [/Ueberblick/g, '\u00DCberblick'],
      [/ueberblick/g, '\u00FCberblick'],
      [/FUER/g, 'F\u00DCR'],
      [/Fuer/g, 'F\u00FCr'],
      [/\bfuer\b/g, 'f\u00FCr'],
      [/HAENDE/g, 'H\u00C4NDE'],
      [/Haende/g, 'H\u00E4nde'],
      [/haende/g, 'h\u00E4nde'],
      [/ZUGUEBUNGEN/g, 'ZUG\u00DCBUNGEN'],
      [/Zuguebungen/g, 'Zug\u00FCbungen'],
      [/zuguebungen/g, 'zug\u00FCbungen']
    ];

    const ignoredTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'NOSCRIPT', 'CODE', 'PRE']);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent || ignoredTags.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || !/[A-Za-z]*(?:ue|oe|ae|UE|OE|AE)[A-Za-z]*/.test(node.nodeValue)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      let value = node.nodeValue;
      for (const [pattern, replacement] of replacements) value = value.replace(pattern, replacement);
      if (value !== node.nodeValue) node.nodeValue = value;
    }
  }

  function scheduleGlobalPolish(root) {
    injectGlobalPolish();
    window.clearTimeout(textPolishTimer);
    textPolishTimer = window.setTimeout(() => replaceVisibleGermanText(root || document.body), 60);
  }

  function injectFinalPolish() {
    if (document.getElementById(polishStyleId)) return;

    const style = document.createElement('style');
    style.id = polishStyleId;
    style.textContent = `
      body:has(.cart-page) .cart-items-component::before {
        content: none !important;
        display: none !important;
      }

      body:has(.cart-page) .cart-page {
        --sl-cart-surface: rgba(24, 24, 26, 0.9) !important;
        --sl-cart-strong: rgba(18, 18, 20, 0.96) !important;
        --sl-cart-border: rgba(255, 255, 255, 0.12) !important;
        --sl-cart-muted: rgba(245, 245, 247, 0.68) !important;
        --sl-cart-text: #f5f5f7 !important;
      }

      body:has(.cart-page) .cart-page__summary .sl-next-checkout-card {
        display: none !important;
      }

      body:has(.cart-page) .cart-page__summary :is(.cart__summary-container, .cart__container, .cart__container--extend, .cart__summary-totals, .cart__ctas) {
        background: transparent !important;
      }

      body:has(.cart-page) .cart-items__details,
      body:has(.cart-page) .cart-items__quantity,
      body:has(.cart-page) .cart-items__price {
        min-width: 0 !important;
      }

      body:has(.cart-page) .cart-items__title {
        overflow-wrap: anywhere !important;
      }

      body:has(.cart-page) .cart-items__remove::after {
        content: none !important;
      }

      @media (max-width: 640px) {
        html:has(.cart-page),
        body:has(.cart-page) {
          max-width: 100% !important;
          overflow-x: hidden !important;
        }

        body:has(.cart-page) .cart-items-component > .section {
          box-sizing: border-box !important;
          width: calc(100% - 28px) !important;
          max-width: 100% !important;
          margin-inline: auto !important;
          padding-inline: 0 !important;
          overflow-x: clip !important;
        }

        body:has(.cart-page) .cart-page {
          display: block !important;
          box-sizing: border-box !important;
          width: 100% !important;
          max-width: 100% !important;
          padding-inline: 0 !important;
          padding-block: 20px 48px !important;
          overflow-x: clip !important;
        }

        body:has(.cart-page) .cart-page__title,
        body:has(.cart-page) .cart-page__items,
        body:has(.cart-page) .cart-page__summary,
        body:has(.cart-page) .cart-page__more-blocks {
          width: 100% !important;
          max-width: 100% !important;
          margin-inline: 0 !important;
        }

        body:has(.cart-page) .cart-page__items {
          margin-top: 22px !important;
        }

        body:has(.cart-page) .cart-items__table,
        body:has(.cart-page) .cart-items__table tbody,
        body:has(.cart-page) .cart-items__table-row,
        body:has(.cart-page) .cart-page__summary {
          box-sizing: border-box !important;
          max-width: 100% !important;
          overflow-x: clip !important;
        }

        body:has(.cart-page) .cart-items__table-row {
          display: flex !important;
          flex-wrap: wrap !important;
          grid-template-columns: none !important;
          gap: 12px !important;
          width: calc(100vw - 60px) !important;
          max-width: calc(100vw - 60px) !important;
          padding: 14px !important;
        }

        body:has(.cart-page) .cart-items__media {
          flex: 0 0 88px !important;
        }

        body:has(.cart-page) .cart-items__media-container {
          width: 88px !important;
        }

        body:has(.cart-page) .cart-items__details {
          flex: 1 1 calc(100vw - 220px) !important;
          max-width: calc(100vw - 220px) !important;
        }

        body:has(.cart-page) .cart-items__title {
          max-width: calc(100vw - 220px) !important;
          font-size: 0.92rem !important;
          line-height: 1.24 !important;
        }

        body:has(.cart-page) .cart-items__price,
        body:has(.cart-page) .cart-items__quantity,
        body:has(.cart-page) .cart-items__error {
          flex: 1 1 100% !important;
          width: 100% !important;
          max-width: 100% !important;
        }

        body:has(.cart-page) .cart-items__quantity-controls {
          justify-content: flex-start !important;
        }

        body:has(.cart-page) .cart-items__remove {
          flex: 0 0 48px !important;
          font-size: 0 !important;
        }

        body:has(.cart-page) .cart__total-value {
          min-width: 0 !important;
          white-space: normal !important;
          overflow-wrap: anywhere !important;
        }

        body:has(.cart-page) .cart-page__summary {
          margin-top: 20px !important;
          width: calc(100vw - 60px) !important;
          max-width: calc(100vw - 60px) !important;
          color: #111113 !important;
          background: #f5f5f7 !important;
        }

        body:has(.cart-page) .cart-page__summary :is(.sla-cart-summary-header, .sla-cart-summary-header *, .cart__total, .cart__total *, .tax-note, .tax-note *, .sl-shipping-progress, .sl-shipping-progress *) {
          color: #111113 !important;
        }

        body:has(.cart-page) .cart-page__summary :is(.cart-actions, .cart__total-container, .cart__summary-totals, .cart__ctas, .cart-discount, disclosure-custom) {
          background: transparent !important;
        }

        body:has(.cart-page) .cart-page__summary .sl-cart-trust {
          background: #ffffff !important;
        }

        body:has(.cart-page) .cart-page__summary .sl-cart-trust span {
          color: #111113 !important;
          background: rgba(215, 255, 34, 0.14) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function cartHasItems() {
    return Boolean(document.querySelector('.cart-items__table-row[data-key], .cart-items__table-row[ref]'));
  }

  function mountSummaryHeader() {
    const summary = document.querySelector('.cart-page__summary');
    if (!summary || summary.querySelector('.sla-cart-summary-header') || !cartHasItems()) return;

    const header = document.createElement('div');
    header.className = 'sla-cart-summary-header';
    header.innerHTML = '<span>Bestelluebersicht</span><strong>Alles bereit fuer deinen sicheren Checkout.</strong>';
    summary.prepend(header);
  }

  function improveCheckoutButton() {
    for (const button of document.querySelectorAll('.cart__checkout-button')) {
      button.setAttribute('aria-label', 'Sicher zum Checkout');
      if (!button.dataset.slaCheckoutText) {
        button.dataset.slaCheckoutText = 'true';
        button.textContent = 'Sicher zum Checkout';
      }
    }
  }

  function mountCheckoutNote() {
    const ctas = document.querySelector('.cart__ctas');
    if (!ctas || ctas.querySelector('.sla-checkout-note') || !cartHasItems()) return;

    const note = document.createElement('div');
    note.className = 'sla-checkout-note';
    note.textContent = 'SSL-verschluesselt. Shop Pay, PayPal und Kreditkarte im Checkout.';
    ctas.appendChild(note);
  }

  function improveQuantityInputs() {
    for (const input of document.querySelectorAll('.cart-items__quantity input[type="number"]')) {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('pattern', '[0-9]*');
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Menge');
    }
  }

  function improveRemoveButtons() {
    for (const button of document.querySelectorAll('.cart-items__remove')) {
      const label = button.getAttribute('aria-label') || 'Artikel entfernen';
      button.setAttribute('title', label);
      button.dataset.label = 'Entfernen';
    }
  }

  function run() {
    scheduleGlobalPolish();
    if (!hasCart()) return;
    injectFinalPolish();
    mountSummaryHeader();
    improveCheckoutButton();
    mountCheckoutNote();
    improveQuantityInputs();
    improveRemoveButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  document.addEventListener('shopify:section:load', run);
  document.addEventListener('cart:update', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
